const options = {
  5: "bg-lime-50/5",
  10: "bg-lime-50/10",
  25: "bg-lime-50/25",
  50: "bg-lime-50/50",
  75: "bg-lime-50/75",
  90: "bg-lime-50/90",
  100: "bg-lime-50",
};

const from = {
  5: "from-lime-50/5",
  10: "from-lime-50/10",
  25: "from-lime-50/25",
  50: "from-lime-50/50",
  75: "from-lime-50/75",
  90: "from-lime-50/90",
  100: "from-lime-50",
};

export default function getBackgroundLime50(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
